import { api } from 'utils/hooks/useApi';

export const createForMoveToTrash = (values: any): Promise<any | boolean> =>
  api().post(`/portal-api/studyRequest/createForMoveToTrash`, values);

export const editRequestForMoveToTrash = (values: any): Promise<any | boolean> =>
  api().post(`/portal-api/studyRequest/editForMoveToTrash`, values);
